import { render, staticRenderFns } from "./sendingRangeSetting.vue?vue&type=template&id=280c9adf&scoped=true&"
import script from "./sendingRangeSetting.vue?vue&type=script&lang=js&"
export * from "./sendingRangeSetting.vue?vue&type=script&lang=js&"
import style0 from "./sendingRangeSetting.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./sendingRangeSetting.vue?vue&type=style&index=1&id=280c9adf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c9adf",
  null
  
)

export default component.exports